__turbopack_context__.v({
  "canvas": "QrCode-module__GEsmPa__canvas",
  "grid": "QrCode-module__GEsmPa__grid",
});
